import { render, staticRenderFns } from "./ArpSelectItens.vue?vue&type=template&id=33f6b21f&scoped=true&"
import script from "./ArpSelectItens.vue?vue&type=script&lang=js&"
export * from "./ArpSelectItens.vue?vue&type=script&lang=js&"
import style0 from "./ArpSelectItens.vue?vue&type=style&index=0&id=33f6b21f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f6b21f",
  null
  
)

export default component.exports